module.exports = __webpack_public_path__ + "img/honor_dxyy.1ec27268.png";